//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addObj, delObj, deleteS, fetchList, putObj } from "@/api/admin/dict";
import dictItem from "@/components/dialog/dictManage/itemList";
import dictAdd from "@/components/dialog/dictManage/addList"; //添加

import dictEdit from "@/components/dialog/dictManage/editList"; //编辑

export default {
  name: "dict",
  components: {
    dictItem: dictItem,
    dictAdd: dictAdd,
    dictEdit: dictEdit
  },
  data: function data() {
    return {
      deleteState: true,
      multipleSelection: [],
      delList: [],
      tableData: [],
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 10,
        // 每页显示多少条
        sizes: [10, 20, 50, 100]
      },
      tableLoading: false,
      params: {
        label: null,
        type: null
      },
      title: "新增",
      showModel: false,
      addForm: {
        id: null,
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      },
      sysFlag: true,
      itemData: {
        state: false,
        data: null
      },
      addData: {
        state: false,
        data: null
      },
      editData: {
        state: false,
        data: null
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getList(this.page, this.params);
  },
  methods: {
    // 设置表格行不可选
    checkSelectable: function checkSelectable(row, index) {
      if (row.system == 1) {
        return false;
      }

      return true;
    },
    delAllSelection: function delAllSelection() {
      var _this = this;

      this.$confirm("点击“确定”按钮删除选中内容，否则请点击“取消”按钮！", "信息消息", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        type: "warning"
      }).then(function () {
        _this.delList = _this.delList.concat(_this.multipleSelection);

        var idArr = _this.multipleSelection.map(function (item) {
          return item.id;
        });

        console.log(idArr, "idArr");
        deleteS(idArr).then(function (res) {
          if (res.data.code == 0) {
            if (_this.tableData.length === idArr.length && _this.page.currentPage > 1) {
              _this.page.total -= 1;
              _this.page.currentPage -= 1;
            }

            _this.$message.success("\u5220\u9664\u6210\u529F");

            _this.multipleSelection = [];

            _this.getList(_this.page, _this.params);
          }
        });
      });
    },
    // 多选操作
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;

      if (this.multipleSelection.length > 0) {
        this.deleteState = false;
      } else {
        this.deleteState = true;
      }
    },

    /**
     * @description: 关闭新增
     * @param:{obj}
     * @return:
     */
    closeAdd: function closeAdd(obj) {
      this.addData.state = false;
      this.getList(this.page, this.params);
    },

    /**
     * @description: 新增
     * @param:{}
     * @return:
     */

    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd: function handleAdd() {
      this.addData.state = true;
    },
    getList: function getList(page, params) {
      var _this2 = this;

      this.tableLoading = true;
      fetchList(Object.assign({
        current: page.currentPage,
        size: page.pageSize
      }, params)).then(function (response) {
        _this2.tableData = response.data.data.records;
        _this2.page.total = response.data.data.total;
        _this2.tableLoading = false;
      });
    },

    /**
     * @description: 关闭编辑
     * @param:{obj}
     * @return:
     */
    closeEdit: function closeEdit(obj) {
      this.editData.state = false;
      this.getList(this.page, this.params);
    },
    handleEdit: function handleEdit(row) {
      this.editData.data = row;
      this.editData.state = true;
      this.$refs.editModal.showEditData();
    },
    handleReset: function handleReset() {
      this.showModel = false;
      this.addForm = {
        id: null,
        value: "",
        type: "",
        label: "",
        description: "",
        remarks: "",
        sort: 0,
        sysFlag: 0
      };
    },

    /**
     * @description: 关闭
     * @param:{}
     * @return:
     */
    closeItem: function closeItem(obj) {
      this.itemData.state = false;
      this.getList(this.page, this.params);
    },

    /**
     * @description: 查看字典项
     * @param:{}
     * @return:
     */
    handleItem: function handleItem(row) {
      this.itemData.data = row;
      this.itemData.state = true;
      this.$refs.dictItem.getItemList();
    },

    /**
     * @description: 删除
     * @param:{}
     * @return:
     */
    handleDel: function handleDel(row) {
      var _this3 = this;

      this.$confirm('"是否确认删除数据类型为"' + row.type + '"的数据项?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        delObj(row.id).then(function (res) {
          if (res.data.code == 0) {
            _this3.getList(_this3.page, _this3.params);
          } else {
            _this3.$alert(res.data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        });
      }).catch(function () {});
    },

    /**
     * 字典更新
     **/
    handleUpdate: function handleUpdate() {
      var _this4 = this;

      this.addForm.sysFlag = this.sysFlag ? 0 : 1;
      putObj(this.addForm).then(function () {
        _this4.$message({
          showClose: true,
          message: "修改成功",
          type: "success"
        });

        _this4.getList(_this4.page, _this4.params);

        _this4.showModel = false;
      });
    },

    /**
     * 字典添加
     **/
    handleSave: function handleSave() {
      var _this5 = this;

      this.addForm.sysFlag = this.sysFlag ? 0 : 1;
      addObj(this.addForm).then(function (data) {
        _this5.tableData.push(Object.assign({}, _this5.addForm));

        _this5.$message({
          showClose: true,
          message: "添加成功",
          type: "success"
        });

        _this5.getList(_this5.page, _this5.params);

        _this5.showModel = false;
      });
    },
    searchChange: function searchChange() {
      this.page.currentPage = 1;
      this.getList(this.page, this.params);
    },
    emptySearch: function emptySearch() {
      this.params = {
        label: null,
        type: null
      };
      this.getList(this.page, this.params);
    },
    changePage: function changePage(num) {
      this.page.currentPage = num;
      this.getList(this.page, this.params);
    },
    changeSize: function changeSize(size) {
      this.page.pageSize = size;
      this.page.currentPage = 1;
      this.getList(this.page, this.params);
    }
  }
};